<ng-container *transloco="let t;">
    <div class="modal-header internal-reminder-header border-bottom-0">
        <div class="d-flex align-items-start gap-75">
            <div class="header-icon">
                <i class="feather icon-bell"></i>
            </div>
            <div>
                <h4 class="modal-title mb-0">{{ t('Internal reminder modal title (Documents Section) - Internal Reminder') }}</h4>
                <small class="text-muted">{{ t('Internal reminder modal subtitle (Documents Section) - Schedule and manage team notifications') }}</small>
            </div>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <form [formGroup]="internalReminderForm">
        <ng-scrollbar class="internal-reminder-scroll" [autoHeightDisabled]="false" visibility="hover">
            <div class="modal-body pt-2" tabindex="0" ngbAutofocus>
                <div class="internal-reminder-card">
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-12 mb-1">
                            <div class="form-group mb-0">
                                <label class="reminder-label">
                                    {{ t('Internal reminder text for field title (Documents Section) - Send reminder to') }}
                                    <i
                                        class="feather icon-info font-small-3 text-muted ml-50 cursor-pointer"
                                        placement="auto"
                                        [ngbTooltip]="t('Internal reminder text for tooltip (Documents Section) - The reminder will be sent to the selected users, even if they dont have permission to view the document Receiving the reminder does not grant any additional access users will only be able to read the reminder itself not the actual document')"
                                        container="body"
                                    ></i>
                                </label>
                                <ng-select
                                    class="reminder-input-select"
                                    [items]="users$ | async"
                                    bindLabel="name"
                                    bindValue="id"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    [placeholder]="t('Internal reminder users placeholder (Documents Section) - Select users')"
                                    formControlName="user_ids"
                                    [ngClass]="{ 'is-invalid error': internalReminderFormSubmitted && reminderFormControls.user_ids.errors }"
                                >
                                    <ng-template ng-multi-label-tmp let-items="items">
                                        <div class="reminder-selected-summary">
                                            {{
                                                items.length === 1
                                                    ? t('Internal reminder users selected singular (Documents Section) - count user selected', { count: items.length })
                                                    : t('Internal reminder users selected plural (Documents Section) - count users selected', { count: items.length })
                                            }}
                                        </div>
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        <div class="d-flex align-items-center">
                                            <div class="avatar avatar-sm mr-1" *ngIf="item.profile_image">
                                                <img [src]="item.profile_image" alt="avatar" height="30" width="30">
                                            </div>
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="internalReminderFormSubmitted && reminderFormControls.user_ids.errors" class="invalid-feedback d-block">
                                    <div *ngIf="reminderFormControls.user_ids.errors.required">{{ t('Please select at least one user') }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-md-6 col-12 mb-1">
                            <div class="form-group mb-0">
                                <label class="reminder-label">{{ t('Text for datetime picker (Documents Section) - Select date and time') }}</label>
                                <div class="col-12 p-0 CC_datePicker">
                                    <input
                                        type="text"
                                        mwlFlatpickr
                                        class="form-control reminder-input"
                                        [altInput]="true"
                                        altFormat="Y-m-d H:i"
                                        dateFormat="Y-m-d H:i"
                                        [enableTime]="true"
                                        [convertModelValue]="true"
                                        [minDate]="minDate"
                                        formControlName="reminder_datetime"
                                        [ngClass]="{ 'is-invalid error': internalReminderFormSubmitted && reminderFormControls.reminder_datetime.errors }"
                                    />
                                    <div
                                        *ngIf="internalReminderFormSubmitted && reminderFormControls.reminder_datetime.errors"
                                        class="invalid-feedback"
                                        [ngClass]="{ 'd-block': internalReminderFormSubmitted && reminderFormControls.reminder_datetime.errors }"
                                    >
                                        <div *ngIf="reminderFormControls.reminder_datetime.errors.required">{{ t('Required text for datetime picker (Documents Section) - Please select date and time') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 mb-0">
                            <label for="Sendmessage" class="reminder-label">{{ t('Text for message (Documents Section) - Message') }}</label>
                            <fieldset class="form-group mb-1">
                                <textarea
                                    class="form-control reminder-textarea"
                                    id="Sendmessage"
                                    rows="3"
                                    [placeholder]="t('Text for message (Documents Section) - Message')"
                                    formControlName="message"
                                    [ngClass]="{ 'is-invalid error': internalReminderFormSubmitted && reminderFormControls.message.errors }"
                                ></textarea>
                                <div *ngIf="internalReminderFormSubmitted && reminderFormControls.message.errors" class="invalid-feedback" [ngClass]="{ 'd-block': internalReminderFormSubmitted && reminderFormControls.message.errors }">
                                    <div *ngIf="reminderFormControls.message.errors.required">{{ t('Required text for message (Documents Section) - Please enter your message') }}</div>
                                </div>
                            </fieldset>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center gap-50">
                            <button type="button" class="btn btn-sm btn-outline-secondary quick-time-btn" (click)="setQuickReminder(1)">{{ t('Internal reminder quick action button (Documents Section) - In 1 hour') }}</button>
                            <button type="button" class="btn btn-sm btn-outline-secondary quick-time-btn" (click)="setTomorrowReminder()">{{ t('Internal reminder quick action button (Documents Section) - Tomorrow') }}</button>
                        </div>
                        <button type="button" class="btn btn-primary add-reminder-btn" (click)="setReminder()">
                            <i class="feather icon-plus mr-50"></i>
                            {{ editingReminderId ? t('Update reminder text for button label (Documents Section) - Update reminder') : t('Set reminder text for button label (Documents Section) - Set reminder') }}
                        </button>
                    </div>
                </div>

                <div class="row mt-2" *ngIf="activeReminders?.length">
                    <div class="col-12">
                        <div class="reminder-section-title active d-flex justify-content-between align-items-center">
                            <h6 class="active-reminder-title text-uppercase fw-bold text-dark tracking-wider mb-0 d-flex align-items-center gap-75">
                                <span class="status-dot bg-success animate-pulse"></span>
                                <span class="active-text">{{ t('Internal reminder section title (Documents Section) - Active reminders') }}</span>
                            </h6>
                            <small class="pending-count">{{ t('Internal reminder pending count (Documents Section) - count pending', { count: pendingCount }) }}</small>
                        </div>
                        <ul class="list-group modern-reminder-list">
                            <li class="list-group-item reminder-card-item active-card" *ngFor="let reminder of activeReminders">
                                <div class="d-flex align-items-center gap-50 mb-75">
                                    <span class="badge reminder-date-chip">{{ reminder.reminder_datetime | date:'MMM dd, yyyy - HH:mm' }}</span>
                                    <span class="badge reminder-status-badge active">{{ t('Internal reminder status badge (Documents Section) - Active') }}</span>
                                </div>

                                <div class="reminder-message mb-75" [title]="reminder.message">{{ reminder.message }}</div>

                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div *ngFor="let user of reminder.users" class="avatar-group" placement="top" [ngbTooltip]="user.name">
                                            <app-user-avatar
                                                [userId]="user.id"
                                                [shortcutName]="user.name | shortName"
                                                cssVariant="avatar-sm"
                                                cssAvatarContent="font-small-1"
                                            ></app-user-avatar>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center action-icons">
                                        <button type="button" class="btn btn-icon btn-flat-primary btn-sm ml-25" (click)="editReminder(reminder)" [title]="t('Edit reminder button tooltip (Documents Section) - Edit reminder')">
                                            <i class="feather icon-edit-2"></i>
                                        </button>
                                        <button type="button" class="btn btn-icon btn-flat-danger btn-sm ml-50" (click)="deleteReminder(reminder.id)" [title]="t('Delete reminder button tooltip (Documents Section) - Delete reminder')">
                                            <i class="feather icon-trash-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="row mt-2" *ngIf="passedReminders?.length">
                    <div class="col-12">
                        <div class="reminder-section-title passed d-flex align-items-center">
                            <i class="feather icon-rotate-ccw section-icon-passed"></i>
                            <span class="passed-text">{{ t('Internal reminder section title (Documents Section) - Passed reminders') }}</span>
                        </div>
                        <ul class="list-group modern-reminder-list">
                            <li class="list-group-item reminder-card-item passed-reminder-item" *ngFor="let reminder of passedReminders">
                                <div class="d-flex align-items-center gap-50 mb-75">
                                    <span class="badge reminder-date-chip passed">{{ reminder.reminder_datetime | date:'MMM dd, yyyy - HH:mm' }}</span>
                                    <span class="badge reminder-status-badge passed">{{ t('Internal reminder status badge (Documents Section) - Passed') }}</span>
                                </div>

                                <div class="reminder-message mb-75" [title]="reminder.message">{{ reminder.message }}</div>

                                <div class="d-flex align-items-center justify-content-between">
                                    <div class="d-flex align-items-center">
                                        <div *ngFor="let user of reminder.users" class="avatar-group" placement="top" [ngbTooltip]="user.name">
                                            <app-user-avatar
                                                [userId]="user.id"
                                                [shortcutName]="user.name | shortName"
                                                cssVariant="avatar-sm"
                                                cssAvatarContent="font-small-1"
                                            ></app-user-avatar>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center action-icons">
                                        <button type="button" class="btn btn-icon btn-flat-primary btn-sm ml-25" (click)="editReminder(reminder)" [title]="t('Edit reminder button tooltip (Documents Section) - Edit reminder')">
                                            <i class="feather icon-edit-2"></i>
                                        </button>
                                        <button type="button" class="btn btn-icon btn-flat-danger btn-sm ml-50" (click)="deleteReminder(reminder.id)" [title]="t('Delete reminder button tooltip (Documents Section) - Delete reminder')">
                                            <i class="feather icon-trash-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </ng-scrollbar>

        <div class="modal-footer internal-reminder-footer">
            <button *ngIf="editingReminderId" type="button" class="btn btn-outline-primary" (click)="cancelEditReminder()" rippleEffect>
                {{ t('Internal reminder cancel edit button (Documents Section) - Cancel edit') }}
            </button>
            <button type="button" class="btn btn-link text-secondary" (click)="closeModal()" rippleEffect>
                {{ t('Cancel button title (cancel button) - Cancel') }}
            </button>
            <button type="button" class="btn btn-primary save-btn" (click)="closeModal()" rippleEffect>
                {{ t('Right menu save button (right menu) - Save changes') }}
            </button>
        </div>
    </form>
</ng-container>
